// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.receivable-history-card {
  padding: 2rem !important;
  position: relative;
}
.receivable-history-card ::-webkit-scrollbar {
  width: 0.475rem;
}
.receivable-history-card ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #e4e9e6;
  background: #e4e9e6;
  border-radius: 10px;
}
.receivable-history-card ::-webkit-scrollbar-thumb {
  background: #0bb599 !important;
  border-radius: 10px;
}
.receivable-history-card ::-webkit-scrollbar-thumb:hover {
  background: #0bb599 !important;
}
@media (max-width: 768px) {
  .receivable-history-card {
    padding: 2rem 0rem 2rem 0rem !important;
  }
}
.receivable-history-card .receivable-history-card-collapse {
  background-color: white;
}
.receivable-history-card .receivable-history-card-collapse .receivable-history-title {
  margin-bottom: -1rem;
  margin-left: -1rem;
}
@media (max-width: 768px) {
  .receivable-history-card .receivable-history-card-collapse .receivable-history-title {
    margin-left: 0rem;
  }
}
.receivable-history-card .receivable-history-card-collapse .receivable-history-table {
  overflow-y: hidden;
  overflow-x: auto;
}
@media (max-width: 768px) {
  .receivable-history-card .receivable-history-card-collapse .receivable-history-table {
    padding: 0rem 1.5rem 0rem 1.5rem !important;
  }
}
.receivable-history-card .receivable-history-card-collapse .receivable-history-status {
  display: inline-block !important;
}
.receivable-history-card .receivable-history-card-collapse .ant-collapse-header {
  margin-right: 0;
  padding-top: 0px;
}
.receivable-history-card .receivable-history-card-collapse .ant-collapse-content-box {
  padding: 0px;
}
.receivable-history-card .receivable-history-card-collapse .ant-collapse-item {
  border-bottom: none;
}
.receivable-history-card .receivable-history-card-collapse .ant-collapse-item svg {
  fill: var(--primary-button-color);
}
`, "",{"version":3,"sources":["webpack://./src/screens/PrePaymentScreen/components/PrepaymentHistory/styles.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,kBAAA;AACF;AAHA;EAKI,eAAA;AACJ;AANA;EASI,iCAAA;EACA,mBAAA;EACA,mBAAA;AAAJ;AAXA;EAeI,8BAAA;EACA,mBAAA;AADJ;AAfA;EAoBI,8BAAA;AAFJ;AAKE;EAAA;IACE,uCAAA;EAFF;AACF;AAvBA;EA4BI,uBAAA;AAFJ;AA1BA;EA+BM,oBAAA;EACA,kBAAA;AAFN;AAIM;EAAA;IACE,iBAAA;EADN;AACF;AAnCA;EAwCM,kBAAA;EACA,gBAAA;AAFN;AAIM;EAAA;IACE,2CAAA;EADN;AACF;AA5CA;EAiDM,gCAAA;AAFN;AA/CA;EAqDM,eAAA;EACA,gBAAA;AAHN;AAnDA;EA0DM,YAAA;AAJN;AAtDA;EA8DM,mBAAA;AALN;AAzDA;EAiEQ,iCAAA;AALR","sourcesContent":[".receivable-history-card {\n  padding: 2rem !important;\n  position: relative;\n\n  ::-webkit-scrollbar {\n    width: 0.475rem;\n  }\n\n  ::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px #e4e9e6;\n    background: #e4e9e6;\n    border-radius: 10px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: #0bb599 !important;\n    border-radius: 10px;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background: #0bb599 !important;\n  }\n\n  @media (max-width: @md-screen) {\n    padding: 2rem 0rem 2rem 0rem !important;\n  }\n\n  .receivable-history-card-collapse {\n    background-color: white;\n\n    .receivable-history-title {\n      margin-bottom: -1rem;\n      margin-left: -1rem;\n\n      @media (max-width: @md-screen) {\n        margin-left: 0rem;\n      }\n    }\n\n    .receivable-history-table {\n      overflow-y: hidden;\n      overflow-x: auto;\n\n      @media (max-width: @md-screen) {\n        padding: 0rem 1.5rem 0rem 1.5rem !important;\n      }\n    }\n\n    .receivable-history-status {\n      display: inline-block !important;\n    }\n\n    .ant-collapse-header {\n      margin-right: 0;\n      padding-top: 0px;\n    }\n\n    .ant-collapse-content-box {\n      padding: 0px;\n    }\n\n    .ant-collapse-item {\n      border-bottom: none;\n\n      svg {\n        fill: var(--primary-button-color);\n      }\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
